// src/components/Navbar/NavbarScroll.js
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AppBar, Toolbar, Typography, Box, useTheme, useMediaQuery } from "@mui/material"
import logo from "../../static/media/logo_menu_darck.webp"
import Search from "./Search"
import NavbarMobile from "./NavbarMobile"
import "../Navbar.css"

const pages = [
  { name: "INICIO", path: "/" },
  { name: "NOSOTROS", path: "/acerca-de-nosotros" },
  { name: "SERVICIOS", path: "/servicios" },
  { name: "TIENDA", path: "/categorias" },
  { name: "CONTACTO", path: "/contacto" }
]

export default function NavbarScroll() {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/"
    return location.pathname.startsWith(path)
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: "1rem" }}>
      <AppBar
        position="fixed"
        sx={{
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "90%",
          borderRadius: 4,
          background: "rgba(0,0,0,0.85)",
          backdropFilter: "blur(6px)",
          boxShadow: "0 4px 10px rgba(0,0,0,0.4)",
          zIndex: 1200
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 2, md: 6 },
            py: 1
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
            <img src={logo} alt="Logo" style={{ height: "45px" }} />
            {!isMobile && (
              <Box
                className="nav-search"
                sx={{
                  maxWidth: 250,
                  width: "100%",
                  "& .MuiOutlinedInput-root": { borderRadius: "999px", background: "#fff" },
                  "& .MuiInputBase-input": { padding: "6px 10px", fontSize: ".95rem", color: "#111" },
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" }
                }}
              >
                <Search isMobile={false} />
              </Box>
            )}
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
            {pages.map((page) => (
              <Typography
                key={page.name}
                variant="body1"
                onClick={() => navigate(page.path)}
                sx={{
                  color: isActive(page.path) ? "#ff6700" : "white",
                  fontWeight: 600,
                  cursor: "pointer",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  transition: "0.3s",
                  "&:hover": { color: "#ff6700" }
                }}
              >
                {page.name}
              </Typography>
            ))}
          </Box>

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <NavbarMobile
              cartCount={0}
              showLogged={false}
              isActive={isActive}
              navigate={navigate}
              onLogin={() => {}}
              onLogout={async () => {}}
              onAccount={() => {}}
            />
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
